import React from 'react';
import load_ic from '../../assets/images/load-ic.svg';
import check_ic from '../../assets/images/check-ic.svg';
import error_ic from '../../assets/images/red-close.svg';

export const TrainingRequestModal = (props) => {

    return (
        <div className="popup-msg-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div
                            className={`popup-msg ${props.response ? 'popup-msg' : props.load ? 'popup-msg' : 'popup-msg-error'}`}>
                            {
                                props.load && (
                                    <>
                                        <h5>Your enquiry is being processed</h5>
                                        <img src={load_ic} alt="icon" className="load-ic"/>
                                    </>)
                            }
                            {
                                !props.load && (
                                    <>
                                        <h5>{props.response ? 'Thank you for submitting your details' : 'Processing error'} </h5>
                                        <img src={props.response ? check_ic : error_ic} alt="icon"/>
                                        <p>{props.response ? 'We will consider your enquiry and will be in touch ' +
                                            'to suggest alternative training arrangements, if possible' :
                                            (props.errorMessage.response &&
                                            props.errorMessage.response.data &&
                                            props.errorMessage.response.data.messageUser ?
                                                props.errorMessage.response.data.messageUser :
                                                props.errorMessage.toString())}  </p>
                                        <button className="btn" onClick={(e) => {
                                            e.preventDefault();
                                            props.closeModal()
                                        }}>ok
                                        </button>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default TrainingRequestModal;